import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = "bkprod_token";

export const api = axios.create({ baseURL: API });

/** Message d'erreur toujours renvoyé sous forme de chaîne (un objet passé à toast fait planter React). */
export const errMsg = (e, fallback = "Une erreur est survenue") => {
  const detail = e?.response?.data?.detail ?? e?.response?.data?.message;
  if (typeof detail === "string" && detail) return detail;
  if (Array.isArray(detail)) {
    const lignes = detail.map((d) => (typeof d === "string" ? d : d?.msg)).filter(Boolean);
    if (lignes.length) return lignes.join(" · ");
  }
  if (detail && typeof detail === "object") return JSON.stringify(detail).slice(0, 200);
  if (typeof e?.message === "string" && e.message) return e.message;
  return fallback;
};

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const DOMAINES = [
  { key: "electricite", label: "Électricité", icon: "Zap", image: "https://images.unsplash.com/photo-1659474122276-aa162e37367a" },
  { key: "videosurveillance", label: "Vidéosurveillance", icon: "Cctv", image: "https://images.unsplash.com/photo-1557597774-9d273605dfa9?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { key: "loxone", label: "Loxone", icon: "Cpu", image: "https://images.unsplash.com/photo-1752262167753-37a0ec83f614" },
  { key: "climatisation", label: "Climatisation", icon: "Wind", image: "https://images.unsplash.com/photo-1762341123870-d706f257a12e" },
  { key: "reseau_informatique", label: "Réseau informatique", icon: "Network", image: "https://images.unsplash.com/photo-1695668548342-c0c1ad479aee?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
  { key: "panneau_solaire", label: "Panneaux solaires", icon: "SunMedium", image: "https://images.unsplash.com/photo-1558449028-b53a39d100fc?crop=entropy&cs=srgb&fm=jpg&q=85&w=900" },
];

export const mediaUrl = (url) => (!url ? null : url.startsWith("http") || url.startsWith("data:") ? url : `${BACKEND_URL}${url}`);

export const domaineLabel = (key) => DOMAINES.find((d) => d.key === key)?.label || key;

export const URGENCES = [
  { key: "bloquant", label: "Bloquant", definition: "Installation hors service / sécurité (alarme, portail bloqué, disjoncteur qui saute)", sla: "Prise en charge < 2h ouvrées", color: "#EF4444" },
  { key: "genant", label: "Gênant", definition: "Fonctionne en dégradé (une caméra HS, appli lente)", sla: "Prise en charge sous 1 jour ouvré", color: "#F59E0B" },
  { key: "mineur", label: "Mineur", definition: "Confort / question", sla: "Prise en charge sous 3 jours ouvrés", color: "#10B981" },
];

export const STATUTS = [
  { key: "recu", label: "Reçu" },
  { key: "qualifie", label: "Qualifié" },
  { key: "planifie", label: "Planifié" },
  { key: "en_cours", label: "En cours" },
  { key: "resolu", label: "Résolu" },
];

export const statutLabel = (key) => STATUTS.find((s) => s.key === key)?.label || key;

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("fr-FR", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const compressImage = (file, maxSize = 1280, quality = 0.7) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const img = new Image();
      img.onload = () => {
        const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
        const canvas = document.createElement("canvas");
        canvas.width = Math.round(img.width * scale);
        canvas.height = Math.round(img.height * scale);
        canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
        resolve(canvas.toDataURL("image/jpeg", quality));
      };
      img.onerror = reject;
      img.src = reader.result;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
